import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Avatar,
  Typography,
  Input,
  Select,
} from "antd";
import { PlusOutlined, SearchOutlined, ToTopOutlined } from "@ant-design/icons";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

const { Title } = Typography;

// table code start
const columns = [
  {
    title: "CLIENT NAME",
    dataIndex: "clientName",
    key: "clientName",
    width: "32%",
  },
  {
    title: "CLIENT ID",
    key: "clientId",
    dataIndex: "clientId",
  },
];

function Clients() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState();

  const [selectedClient, setSelectedClient] = useState("All Clients");

  const [query, setQuery] = useState("");

  const data = clients
    ?.filter((client) =>
      query === ""
        ? client
        : client.name.toLowerCase().includes(query.toLowerCase())
    )
    // .filter((user) =>
    //   selectedCompany === "All Companies"
    //     ? user
    //     : user.company === selectedCompany
    // )
    .map((client) => {
      return {
        key: client?.id,
        clientName: (
          <>
            <Avatar.Group>
              {/*<Avatar*/}
              {/*  className="shape-avatar"*/}
              {/*  shape="square"*/}
              {/*  size={40}*/}
              {/*  src={face}*/}
              {/*></Avatar>*/}
              <div className="avatar-info">
                <Title level={5}>{client?.name}</Title>
                {/*<p>{?.email}</p>*/}
              </div>
            </Avatar.Group>{" "}
          </>
        ),
        // function: (
        //   <>
        //     <div className="author-info">
        //       <Title level={5}>Inspector</Title>
        //       <p>Premium Security</p>
        //     </div>
        //   </>
        // ),

        // status: (
        //   <>
        //     <Button
        //       className={user?.active ? "tag-primary" : "tag-badge"}
        //       style={{ cursor: "auto" }}
        //     >
        //       {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
        //     </Button>
        //   </>
        // ),
        clientId: (
          <>
            <div className="ant-employed">
              <span>{client?.id}</span>
              <Link
                style={{ marginLeft: "10px", color: "#1EC8FF" }}
                to={`client/${client?.id}`}
              >
                Edit
              </Link>
            </div>
          </>
        ),
      };
    });

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setClients(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedClient(value);
  };

  const exportClients = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          "csvExport/exportClientsToCSV?separator=%2C",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "text/csv",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "clients.csv");

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Clients"
              extra={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {/*<Select*/}
                  {/*  // defaultValue={societatiPaza[0].value}*/}
                  {/*  value={selectedCompany}*/}
                  {/*  style={{*/}
                  {/*    width: 200,*/}
                  {/*    marginRight: "10px",*/}
                  {/*    height: "100%",*/}
                  {/*    marginBottom: "10px",*/}
                  {/*    marginTop: "10px",*/}
                  {/*  }}*/}
                  {/*  onChange={handleChange}*/}
                  {/*  options={societatiPaza}*/}
                  {/*/>*/}
                  <Input
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                    size="small"
                    prefix={
                      <SearchOutlined
                        size="small"
                        // style={{
                        //   backgroundColor: "red",
                        //   padding: "0px",
                        //   margin: "0px",
                        //   height: "10px",
                        // }}
                        className="site-form-item-icon"
                      />
                    }
                    placeholder="Search client"
                    onChange={(e) => setQuery(e.target.value)}
                    // style={{ width: 150, height: "100%" }}
                  />
                  <NavLink
                    to="/add-client"
                    style={{
                      marginBottom: "10px",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                  >
                    <Button type="secondary" className="tag-primary">
                      <PlusOutlined />
                      Add Client
                    </Button>
                  </NavLink>
                  <Button
                    onClick={() => exportClients()}
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                    type="secondary"
                    className="tag-secondary"
                  >
                    Export Clients
                  </Button>
                  {/*<Input*/}
                  {/*  style={{ marginLeft: "20px" }}*/}
                  {/*  className="header-search"*/}
                  {/*  placeholder="Type here..."*/}
                  {/*  prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                {loading ? (
                  <Spinner />
                ) : (
                  <Table
                    style={{ padding: "10px" }}
                    columns={columns}
                    dataSource={data}
                    pagination={true}
                    className="ant-border-space"
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Clients;
